import 'assets/index.scss'
import type { App } from 'vue'
import Avatar from './Avatar/index.vue'
import Dialog from './Dialog/index.vue'
import { useElementPlus } from './element-plus'
import PageHeader from './PageHeader/index.vue'
import Pagination from './Pagination/index.vue'
import { useCasl } from './casl'
export default {
  install: (app: App) => {
    // Register it globally
    // app.component('LogoImg', LogoImg)
    app.component('Avatar', Avatar)
    app.component('Dialog', Dialog)
    app.component('PageHeader', PageHeader)
    app.component('Pagination', Pagination)
    // Element Plus
    useElementPlus(app)
    // Casl
    useCasl(app)
  },
}
